export type PromptAnswerText = { question: string; answer: string };

export const SKIPPED_PROMPT_ANSWER = "(skipped)";

export const formatSelectedOptionLabels = (labels: string[]): string =>
  labels.join(", ");

/** The answers as one message, which is what an agent reads. */
export const formatPromptAnswers = (answers: PromptAnswerText[]): string =>
  answers
    .map(({ question, answer }) => `Q: ${question}\nA: ${answer}`)
    .join("\n\n");
